import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    cardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: '16px',
      paddingLeft: '0px',
      lineHeight: '10px'
    },
    medicineDetailsContainer: {
      marginBottom: '8px'
    },
    margiTop16: {
      marginTop: '16px'
    },
    backButton: {
      textTransform: 'capitalize',
      marginRight: '12px',
    },
    addMedicineButton: {
      marginRight: '38px'
    }
  };
});
